import Nav from "@/landing/Nav";
import Hero from "@/landing/Hero";
import StickyCta from "@/landing/StickyCta";
import { VideoSusana, PainSection, TrainedSection, BridgeSection, ImageBand } from "@/landing/Story";
import { MethodSection, LearnSection, ExperienceSection } from "@/landing/Method";
import { TestimonialsSection, AboutSection, FacultySection } from "@/landing/Proof";
import { BonusSection, ApplicationSection, FaqSection, Footer } from "@/landing/Closing";
import PricingSection from "@/landing/Pricing";
import EditionsSection from "@/landing/Editions";

export default function Landing() {
  return (
    <main className="bg-cream">
      <Nav />
      <Hero />
      <VideoSusana />
      <PainSection />
      <TrainedSection />
      <ImageBand />
      <BridgeSection />
      <MethodSection />
      <LearnSection />
      <ExperienceSection />
      <TestimonialsSection />
      <AboutSection />
      <FacultySection />
      <BonusSection />
      <EditionsSection />
      <PricingSection />
      <ApplicationSection />
      <FaqSection />
      <Footer />
      <StickyCta />
    </main>
  );
}
